import { httpsCallable } from 'firebase/functions';
import { functions } from '../utils/firebase';
import {
  CALLABLE_EMAIL_LIST_BREWERY_ACTIVITY_EMAILS,
  CALLABLE_EMAIL_PREPARE_BREWERY_ACTIVITY_EMAILS,
  CALLABLE_EMAIL_PREVIEW_BREWERY_ACTIVITY_EMAIL,
  CALLABLE_EMAIL_SEND_BREWERY_ACTIVITY_EMAIL,
} from '../utils/callableEmailConstants';

export async function listBreweryActivityEmails(filters = {}) {
  const callable = httpsCallable(functions, CALLABLE_EMAIL_LIST_BREWERY_ACTIVITY_EMAILS);
  const response = await callable(filters);
  return response.data;
}

export async function previewBreweryActivityEmail(emailId) {
  const callable = httpsCallable(functions, CALLABLE_EMAIL_PREVIEW_BREWERY_ACTIVITY_EMAIL);
  const response = await callable({ emailId });
  return response.data;
}

export async function sendBreweryActivityEmail(emailId) {
  const callable = httpsCallable(functions, CALLABLE_EMAIL_SEND_BREWERY_ACTIVITY_EMAIL, {
    timeout: 120000,
  });
  const response = await callable({ emailId });
  return response.data;
}

export async function prepareBreweryActivityEmails(options = {}) {
  const callable = httpsCallable(functions, CALLABLE_EMAIL_PREPARE_BREWERY_ACTIVITY_EMAILS, {
    timeout: 540000,
  });
  const response = await callable(options);
  return response.data;
}
